import {Skeleton} from "@heroui/react";

export default function InputSkeleton() {
  return (
    <div className="max-w-[300px] w-full flex items-center gap-3">
      <div className="w-full flex flex-col gap-2">
        <Skeleton className="h-3 w-4/5 rounded-lg"/>
      </div>
    </div>
  );
}
